import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=be5cc2f2&"
import script from "./ProfilePage.vue?vue&type=script&lang=js&"
export * from "./ProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports